export default __webpack_public_path__ + "static/img12h-effec9e75a906604dbd12c1c978248f4.jpg";